import React from 'react';

interface LogoProps {
  className?: string;
}

export function Logo({ className = '' }: LogoProps) {
  return (
    <span className={className}>
      <span className="font-alice">Aligned</span> <span className="font-normal">Workbench</span>
    </span>
  );
}
